import { Divider, DividerProps, styled } from '@mui/material';

interface PrimaryDividerProps extends DividerProps {
  opacity?: number;
  color?: string;
}

/**
 * Standard divider to be reused across app.
 * @param {number | undefined} opacity Optionally specify a custom opacity for the divider clarity.
 * @param {string | undefined} color Optionally specify a custom color for the divider.
 * @returns {JSX.Element}
 */
const PrimaryDivider = styled(Divider)<PrimaryDividerProps>(({ theme, opacity, color }) => ({
  opacity: opacity,
  backgroundColor: color ? color : theme.palette.secondary.main,
  boxShadow: 'none',
  transition: theme.transitions.create(['width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  })
}));

export default PrimaryDivider;
